<template>
  <div class="teacher-content" v-loading="!data.info">
    <template v-if="data.info">
      <div class="container content">
        <el-row :gutter="50">
          <el-col :sm="12">
            <div class="teacher-info">
              <div class="card">
                <el-image class="cover" fit="cover" :src="data.info.pic"></el-image>
                <div class="card-info">
                  <h1>
                    <i class="iconfont iconmingshi"></i>
                    {{ data.info.name }}
                  </h1>
                  <div class="position">{{ data.info.job }}</div>
                  <div class="introduction">{{ data.info.desc1 }}[详细]</div>
                </div>
              </div>
              <div class="teachers-message">
                <h1>
                  <i class="iconfont iconmingshijiyu"></i>
                  名师寄语
                </h1>
                <div class="message">{{ data.info.spokenWords }}</div>
              </div>
            </div>
          </el-col>
          <el-col :sm="12">
            <h1 class="area-title underline">
              <span class="red-border">示范课程</span>
              <el-button
                class="view-more-btn"
                type="danger"
                size="mini"
                plain
                @click="viewCourse"
              >查看更多 &gt;</el-button>
            </h1>
            <div class="can-click" @click="viewCourse" v-if="data.course">
              <el-image class="course-video" fit="cover" :src="data.course.cover"></el-image>
              <div class="video-name pc">{{ data.course.name }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row class="row-2" :gutter="50">
          <el-col :sm="12">
            <h1 class="area-title underline">
              <span class="red-border">近期动态</span>
              <el-button
                class="view-more-btn"
                type="danger"
                size="mini"
                plain
                @click="viewMoreNews(1)"
              >查看更多 &gt;</el-button>
            </h1>
            <div class="news-list">
              <div
                class="news-item can-click"
                :class="{ 'first': index === 0 }"
                v-for="(item, index) in data.news"
                :key="index"
                @click="viewNewsContent(1, item.id)"
              >
                <h2 class="name">{{ item.title }}</h2>
                <div class="detail">{{ item.content }}</div>
              </div>
            </div>
          </el-col>
          <el-col :sm="12">
            <h1 class="area-title underline">
              <span class="red-border">活动展示</span>
            </h1>
            <el-carousel :interval="4000" type="card" height="200px">
              <el-carousel-item v-for="(item, index) in data.activities" :key="index">
                <div class="activity-item">
                  <el-image class="cover" fit="cover" :src="item.url"></el-image>
                  <div class="name">{{ item.title }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
        <h1 class="area-title pc">教学心得</h1>
      </div>
      <div class="teaching-experience">
        <div class="container">{{ data.info.thinking }}</div>
      </div>
      <div class="container content-2">
        <el-row :gutter="50">
          <el-col :sm="12">
            <h1 class="area-title underline">
              <span class="red-border">理论文章</span>
              <el-button
                class="view-more-btn"
                type="danger"
                size="mini"
                plain
                @click="viewMoreNews(2)"
              >查看更多 &gt;</el-button>
            </h1>
            <div class="article-list">
              <div
                class="article-item can-click"
                v-for="(item, index) in data.articles"
                :key="index"
                @click="viewNewsContent(2, item.id)"
              >
                <span class="name">{{ item.title }}</span>
              </div>
            </div>
          </el-col>
          <el-col :sm="12">
            <h1 class="area-title underline">
              <span class="red-border">媒体关注</span>
              <el-button
                class="view-more-btn"
                type="danger"
                size="mini"
                plain
                @click="viewMoreNews(3)"
              >查看更多 &gt;</el-button>
            </h1>
            <div class="article-list">
              <div
                class="article-item can-click"
                v-for="(item, index) in data.reports"
                :key="index"
                @click="viewNewsContent(3, item.id)"
              >
                <span class="name">{{ item.title }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
import { teacherContent } from "@/api/api.js";

export default {
  name: "teacherContent",
  props: ["id"],
  data() {
    return {
      data: {}
    };
  },
  created() {
    teacherContent(this.id)
      .then(res => {
        // 返回数据
        if(res.activities && res.activities.length){
          res.activities = JSON.parse(res.activities[0].attach);
        }
        this.data = res;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewCourse() {
      window.open(
        `http://mooc.people.cn/publicCourse/index.html#/index/courseDetail?courseId=${this.data.course.id}`
      );
    },
    viewMoreNews(type) {
      this.$router.push(`../teacherNews/${this.id}/${type}`);
    },
    viewNewsContent(type, id) {
      this.$router.push(`../teacherNews/${this.id}/${type}/${id}`);
    }
  }
};
</script>

<style scoped>
.content {
  margin-top: 40px;
}

.area-title {
  font-size: 22px;
  line-height: 32px;
  color: #444;
}

.underline {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e3e3e3;
}

.underline .red-border {
  padding-bottom: 16px;
  border-bottom: 1px solid #7691ff;
}

.teacher-content .view-more-btn {
  float: right;
  vertical-align: top;
}

.teacher-info {
  padding: 18px;
  color: #444;
  background-color: unset;
  background-image: linear-gradient(231deg, #C5D8ED 0%, #E5E8FF 100%);
  border-radius: 4px;
}

.card {
  position: relative;
}

.card .cover {
  position: absolute;
  width: 195px;
  height: 260px;
  background-color: #eee;
  border: none;
}

.card .card-info {
  min-height: 272px;
  padding-left: 219px;
}

.card h1 {
  margin-bottom: 6px;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  overflow: hidden;
}

.card h1 .iconfont {
  margin-left: 1px;
  margin-right: 8px;
  font-size: 22px;
  font-weight: normal;
  color: #fd4101;
}

.card .position {
  height: 48px;
  line-height: 24px;
  font-size: 15px;
  font-weight: bold;
  overflow: hidden;
}

.card .introduction {
  margin-top: 28px;
  height: 140px;
  line-height: 28px;
  font-size: 14px;
  text-indent: 28px;
  overflow: hidden;
}

.teachers-message {
  margin-top: 26px;
}

.teachers-message h1 {
  line-height: 22px;
  font-size: 16px;
}

.teachers-message .iconfont {
  margin-right: 8px;
  font-size: 16px;
  font-weight: normal;
  color: #7691ff;
}

.teachers-message .message {
  margin-top: 12px;
  height: 56px;
  line-height: 28px;
  font-size: 14px;
  text-indent: 28px;
  overflow: hidden;
}

.course-video {
  display: block;
  width: 100%;
  height: 316px;
  background-color: #000;
}

.video-name {
  margin-top: 20px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
}

.row-2 {
  margin-top: 48px;
  margin-bottom: 32px;
}

.news-list {
  margin-top: -20px;
}

.news-item {
  padding-top: 20px;
  padding-bottom: 15px;
  border-top: 1px dashed #d5d5d5;
}

.news-item.first {
  border-top: unset;
}

.news-item .name {
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  overflow: hidden;
}

.news-item .detail {
  margin-top: 12px;
  height: 48px;
  line-height: 24px;
  font-size: 14px;
  text-indent: 28px;
  color: #888;
  overflow: hidden;
}

.activity-item {
  position: relative;
  height: 100%;
}

.activity-item .cover {
  display: block;
  height: 100%;
  background-color: #eee;
}

.activity-item .name {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  line-height: 28px;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}

.is-active .activity-item .name {
  display: unset;
}

.teaching-experience {
  margin-top: 16px;
  padding: 50px;
  font-size: 18px;
  line-height: 32px;
  text-indent: 36px;
  color: #fff;
  background-image: url("~@/assets/images/hnkc/red-background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.teaching-experience > .container{
  position: relative;
  padding-left: 60px;
  padding-right: 60px;
}
.teaching-experience > .container::before {
  position: absolute;
  top: -30px;
  left: 0;
  content: ' ';
  display: block;
  width: 40px;
  height: 40px;
  background: url("~@/assets/images/hnkc/quotationMarks_left.png") no-repeat center center;
}
.teaching-experience > .container::after {
  position: absolute;
  bottom: -30px;
  right: 0;
  content: ' ';
  display: block;
  width: 40px;
  height: 40px;
  background: url("~@/assets/images/hnkc/quotationMarks_right.png") no-repeat center center;
}

.content-2 {
  margin-top: 60px;
  margin-bottom: 80px;
}

.article-list {
  margin-top: -6px;
}

.article-item {
  padding: 10px 0;
  border-bottom: 1px dashed #d5d5d5;
}

.article-item .name {
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
}

@media (max-width: 767px) {

  .content {
    margin-top: 15px;
  }

  .area-title {
    font-size: 16px;
    line-height: 16px;
  }

  .underline {
    margin-top: 30px;
  }

  .underline .red-border {
    padding-bottom: 12px;
  }

  .teacher-content .view-more-btn {
    margin-top: -8px;
  }

  .row-2 {
    margin-top: 0;
    margin-bottom: 26px;
  }

  .course-video {
    height: 206px;
  }

  .teaching-experience {
    padding: 42px 0;
    font-size: 13px;
    line-height: 18px;
  }

  .content-2 {
    margin-top: 0;
    margin-bottom: 30px;
  }
}
</style>
